// Brain Dump Login Page - Simple password gate

import { useState, type FormEvent } from 'react';
import { brainDumpService } from '../services/brainDump';
import styles from './BrainDumpLoginPage.module.css';

interface BrainDumpLoginPageProps {
  onAuthenticated: () => void;
}

export function BrainDumpLoginPage({ onAuthenticated }: BrainDumpLoginPageProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (!password) {
      setError('Enter the access code');
      return;
    }

    setIsLoading(true);

    try {
      const success = await brainDumpService.authenticate(password);
      if (success) {
        onAuthenticated();
      } else {
        setError('Wrong code. Try again.');
      }
    } catch {
      setError('Something went wrong. Try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginBox}>
        {/* Logo */}
        <div className={styles.logoSection}>
          <div className={styles.logoMark}>CM</div>
          <h1 className={styles.title}>Brain Dump</h1>
          <p className={styles.subtitle}>
            Quick capture for trip reports, call notes, emails, ideas, and more
          </p>
        </div>

        {/* Login form */}
        <form onSubmit={handleSubmit} className={styles.form}>
          {error && (
            <div className={styles.error} role="alert">
              {error}
            </div>
          )}

          <input
            type="password"
            className={styles.passwordInput}
            placeholder="Access code"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            autoFocus
          />

          <button
            type="submit"
            className={styles.submitButton}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className={styles.spinner} />
            ) : (
              'Enter'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
